// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1xrSh","TopHeader":"Header_TopHeader__3nPUS","IconsContainer":"Header_IconsContainer__3e7st","Image":"Header_Image__1HRcQ"};